<script setup>
import { defineProps } from 'vue'

import AttendanceMark from '@/components/journal/parent/child/AttendanceMark.vue'

defineProps({
  pending: Boolean,
  confirmed: Boolean,
  unpaid: Boolean,
  absent: Boolean
})
</script>

<template>
  <ul class="legend">
    <li v-if="confirmed"><AttendanceMark confirmed /> посещение оплачено</li>
    <li v-if="pending"><AttendanceMark pending /> списание средств в процессе</li>
    <li v-if="unpaid"><AttendanceMark unpaid /> не хватает средств для оплаты</li>
    <li v-if="absent"><AttendanceMark /> ребёнок отсутствовал на занятии</li>
  </ul>
</template>

<style scoped>
.legend {
  list-style: none;
  padding: 0;
  margin: 2em 0 0 0;
}

.legend li {
  line-height: 1.7em;
}
</style>
